import { Ref } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { useHeaderStore } from '@/stores/header';

import { api } from './_http';

type GetEventRiseData = {
	event_rise: EventRise[];
};
export type EventRise = {
	master_name: string;
	event_name: string;
	event_rise_ratio: string;
};

// 주간 상승률 조회
export const useGetEventRiseApi = () => {
	const url = '/v1/front/usa/getEventRise';
	return useQuery<AxiosResponse, AxiosError, GetEventRiseData>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => {
			return res.data.data;
		},
	});
};
type GetEventSearchParams = Ref<{
	search: string;
}>;
type GetEventSearchData = {
	search_result: EventSearch[];
};
export type EventSearch = {
	event_name: string;
	event_pk: number;
	event_identifier: string;
	file_path: string;
	country: string;
};

// 주간 상승률 조회
export const useGetEventSearchApi = (params: GetEventSearchParams, enabled: Ref<boolean>, all?: boolean) => {
	const url = '/v1/front/getEventSearch';
	const headerStore = useHeaderStore();
	console.log('headerStore.getCountry:', headerStore.getCountry);
	return useQuery<AxiosResponse, AxiosError, GetEventSearchData>({
		queryKey: [url, params],
		queryFn: () => api.get(url, { ...params.value, country: all ? '' : headerStore.getCountry }),
		select: (res) => {
			return res.data.data;
		},
		enabled: enabled,
	});
};

// 프리미엄 이벤트 수집
export const usePremiumEventCollectApi = () => {
	const url = '/v1/front/getPremiumView';
	return useMutation<AxiosResponse, AxiosError>({
		mutationFn: () => api.get(url),
	});
};
